import { render, staticRenderFns } from "./HelpIfream.vue?vue&type=template&id=12e101bc&scoped=true"
import script from "./HelpIfream.vue?vue&type=script&lang=js"
export * from "./HelpIfream.vue?vue&type=script&lang=js"
import style0 from "./HelpIfream.vue?vue&type=style&index=0&id=12e101bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e101bc",
  null
  
)

export default component.exports